import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Rating,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import NoEntry from "./NoEntry";
function PostReview() {
  const { id } = useParams();
  const [userId, setUserId] = useState(-1);
  const [des, setDes] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [navigat, setNavigat] = useState(false);

  const [value, setValue] = useState(0);
  const [result, setResult] = useState([]);
  const fontFamily = process.env.REACT_APP_FONT || "Assistant";
  const ratingLabels = {
    0.5: "טעון שיפור משמעותי",
    1: "לא מרוצה",
    1.5: "מתחת לציפיות",
    2: "טעון שיפור",
    2.5: "סביר",
    3: "טוב",
    3.5: "טוב מאוד",
    4: "מרוצה מאוד",
    4.5: "מצוין",
    5: "חוויה מעולה",
  };
  useEffect(() => {
    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/getresult?id=${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.Result[0].major.toString() !== "3")
          setResult(res.data.Result[0]);
        else setResult(res.data.Result[1]);
        setUserId(res.data.UserId.user_id);
      })
      .catch((err) => console.log(err));
  }, [id]);
  const handleSubmit = () => {
    console.log(des);
    setIsLoading(true);
    axios
      .post(
        `${process.env.React_APP_BACKEND_URL}/api/providereview`,
        {
          bidAmount: result.bidAmount,
          bidderId: result.bidderId,
          reviewerId: userId,
          des: des,
          star: value.toString(),
          bidId: result.bidId,
        },
        { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
      )
      .then((res) => {
        setDes("");
        setNavigat(true);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  };
  return (
    <Box
      dir="rtl"
      sx={{
        minHeight: "calc(100vh - 70px)",
        px: { xs: 1.5, sm: 2.5 },
        py: { xs: 3, md: 5 },
        fontFamily,
        background:
          "linear-gradient(180deg, #F5FAFE 0%, #FFFFFF 58%)",
        "& .MuiTypography-root, & .MuiButton-root, & .MuiInputBase-root, & .MuiInputLabel-root": {
          fontFamily,
        },
      }}
    >
      {result.review === "Yes" && (
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: 620,
            mx: "auto",
            p: { xs: 3, sm: 4 },
            borderRadius: "22px",
            border: "1px solid #DCEAF3",
            boxShadow: "0 16px 44px rgba(29, 76, 105, 0.09)",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              width: 58,
              height: 58,
              mx: "auto",
              mb: 1.7,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              color: "#16895F",
              backgroundColor: "#EAF8F2",
            }}
          >
            <CheckCircleRoundedIcon sx={{ fontSize: 34 }} />
          </Box>
          <Typography
            component="h1"
            sx={{
              color: "#173F5F",
              fontWeight: 900,
              fontSize: { xs: "1.35rem", sm: "1.55rem" },
            }}
          >
            חוות הדעת כבר נשלחה
          </Typography>
          <Typography
            sx={{ mt: 0.8, color: "#627888", lineHeight: 1.7 }}
          >
            כבר ניתנה חוות דעת לעבודה הזו ואין צורך למלא אותה שוב.
          </Typography>
          <Button
            component={NavLink}
            to="/home"
            variant="contained"
            sx={{
              mt: 2.5,
              px: 3.2,
              py: 1.05,
              borderRadius: "12px",
              fontWeight: 800,
              textTransform: "none",
              boxShadow: "0 8px 20px rgba(25,118,210,.18)",
            }}
          >
            חזרה לדף הבית
          </Button>
        </Paper>
      )}
      {!isLoading && !navigat && result.review !== "Yes" && (
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: 680,
            mx: "auto",
            overflow: "hidden",
            borderRadius: { xs: "20px", sm: "24px" },
            border: "1px solid #DCEAF3",
            backgroundColor: "#FFFFFF",
            boxShadow: "0 18px 50px rgba(29, 76, 105, 0.10)",
          }}
        >
          <Box
            sx={{
              px: { xs: 2.3, sm: 4 },
              py: { xs: 2.6, sm: 3.2 },
              background:
                "linear-gradient(135deg, #F0F8FE 0%, #F8FCFF 68%, #EFFAF6 100%)",
              borderBottom: "1px solid #E2EDF4",
            }}
          >
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  flex: "0 0 auto",
                  borderRadius: "14px",
                  display: "grid",
                  placeItems: "center",
                  color: "#1479B8",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "0 7px 18px rgba(20,121,184,.12)",
                }}
              >
                <RateReviewRoundedIcon />
              </Box>
              <Box>
                <Typography
                  component="h1"
                  sx={{
                    color: "#173F5F",
                    fontWeight: 900,
                    fontSize: { xs: "1.35rem", sm: "1.65rem" },
                    lineHeight: 1.25,
                  }}
                >
                  איך הייתה החוויה שלך?
                </Typography>
                <Typography sx={{ mt: 0.45, color: "#61798A", fontSize: { xs: "0.91rem", sm: "0.98rem" } }}>
                  חוות הדעת שלך תעזור ללקוחות הבאים לבחור בצורה טובה יותר
                </Typography>
              </Box>
            </Stack>
          </Box>

          <Stack spacing={2.5} sx={{ p: { xs: 2.3, sm: 4 } }}>
            <Box
              sx={{
                p: { xs: 2, sm: 2.5 },
                borderRadius: "16px",
                textAlign: "center",
                backgroundColor: "#FBFCFD",
                border: "1px solid #E5EDF2",
              }}
            >
              <Typography sx={{ color: "#294E67", fontWeight: 800, mb: 1.2 }}>
                מה הדירוג שלך לבעל המקצוע?
              </Typography>
              <Rating
                name="simple-controlled"
                value={value}
                dir="ltr"
                precision={0.5}
                size="large"
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
                sx={{
                  direction: "ltr",
                  fontSize: { xs: "2.35rem", sm: "2.7rem" },
                  color: "#F5A623",
                  "& .MuiRating-iconEmpty": { color: "#D9E2E8" },
                }}
              />
              <Typography
                sx={{
                  mt: 0.8,
                  minHeight: 22,
                  color: value ? "#277B5B" : "#7A8E9B",
                  fontWeight: 700,
                  fontSize: "0.9rem",
                }}
              >
                {value ? `${ratingLabels[value] || "תודה על הדירוג"} - ${value} מתוך 5` : "יש לבחור דירוג בכוכבים"}
              </Typography>
            </Box>

            <TextField
              required
              fullWidth
              multiline
              minRows={4}
              id="title"
              value={des}
              onChange={(e, newValue) => setDes(e.target.value)}
              label="ספר לנו על המקצועיות, האמינות ויחסי האנוש"
              placeholder="מה היה טוב? האם בעל המקצוע עמד בזמנים ובסיכום?"
              name="title"
              InputLabelProps={{ shrink: true }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  alignItems: "flex-start",
                  borderRadius: "14px",
                  backgroundColor: "#FFFFFF",
                  "& fieldset": { borderColor: "#CCDCE6" },
                  "&:hover fieldset": { borderColor: "#7EB5D8" },
                  "&.Mui-focused fieldset": { borderColor: "#1976D2" },
                },
              }}
            />

            <Button
              onClick={handleSubmit}
              disabled={!value}
              fullWidth
              variant="contained"
              size="large"
              sx={{
                py: 1.35,
                borderRadius: "14px",
                fontSize: "1.04rem",
                fontWeight: 900,
                textTransform: "none",
                background: "linear-gradient(135deg, #1976D2 0%, #2596D8 100%)",
                boxShadow: "0 10px 24px rgba(25,118,210,.22)",
                "&:hover": {
                  background: "linear-gradient(135deg, #166CBC 0%, #2188C4 100%)",
                },
              }}
            >
              שליחת חוות הדעת
            </Button>
            <Typography
              sx={{
                mt: "6px !important",
                px: 1,
                textAlign: "center",
                color: "#7A8B97",
                fontSize: "0.82rem",
                lineHeight: 1.55,
              }}
            >
              הדירוג וחוות הדעת יישמרו לאחר הלחיצה על הכפתור
            </Typography>
          </Stack>
        </Paper>
      )}
      {isLoading && (
        <Paper elevation={0} sx={{ width: "100%", maxWidth: 520, mx: "auto", p: 4, borderRadius: "20px", border: "1px solid #DCEAF3", textAlign: "center" }}>
          <CircularProgress />
          <Typography sx={{ mt: 1.5, color: "#365D75", fontWeight: 800 }}>שומרים את חוות הדעת...</Typography>
        </Paper>
      )}
      {navigat && (
        <Paper elevation={0} sx={{ width: "100%", maxWidth: 620, mx: "auto", p: { xs: 3, sm: 4 }, borderRadius: "22px", border: "1px solid #DCEAF3", boxShadow: "0 16px 44px rgba(29,76,105,.09)", textAlign: "center" }}>
          <Box sx={{ width: 58, height: 58, mx: "auto", mb: 1.7, borderRadius: "50%", display: "grid", placeItems: "center", color: "#16895F", backgroundColor: "#EAF8F2" }}>
            <CheckCircleRoundedIcon sx={{ fontSize: 34 }} />
          </Box>
          <Typography component="h1" sx={{ color: "#173F5F", fontWeight: 900, fontSize: { xs: "1.35rem", sm: "1.55rem" } }}>
            חוות הדעת נשלחה בהצלחה
          </Typography>
          <Typography sx={{ mt: 0.8, color: "#627888", lineHeight: 1.7 }}>
            תודה ששיתפת בחוויה שלך. חוות הדעת תעזור ללקוחות נוספים ולבעל המקצוע.
          </Typography>
          <Button component={NavLink} to="/home" variant="contained" sx={{ mt: 2.5, px: 3.2, py: 1.05, borderRadius: "12px", fontWeight: 800, textTransform: "none", boxShadow: "0 8px 20px rgba(25,118,210,.18)" }}>
            חזרה לדף הבית
          </Button>
        </Paper>
      )}
    </Box>
  );
}

export default PostReview;
